import { EfektDekoracyjny } from './ankieta';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'faktura'
})
export class FakturaPipe implements PipeTransform {

  transform(value: EfektDekoracyjny, args?: any): string {
    if (value == EfektDekoracyjny.baranek) {
      return "Faktura nakrapiana, powierzchnia o strukturze grudek - Baranek"
    } else {
      return "Faktura kanalikowa, powierzchnia o strukturze rowków - Kornik"
    }
  }

}
